import React from 'react';

import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ShopifyLogo from "../../../components/images/shopify"
import ImageFooted from '../../../components/widgets/imageFooted';
import { IMG_Shopify } from '../../../components/images/docs/shopify';
import SectionNavigate from '../../../components/widgets/sectionNavigate';
import { TabEntry, Tabulator } from '../../../components/widgets/tabulator';

type DataProps = {
    site: {
        buildTime: string
    }
}

const ShopifyFacturacionCheckout: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isEcommerce={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ShopifyDocs' className="_DOCS">
            <div className="integrationLogo">
                <ShopifyLogo />
            </div>
            <h2>
                Facturación después del Checkout ("Thank You" page)
            </h2>
            <p>
                Cuando un cliente realiza un pedido en linea, en la <b>sección de agradecimiento</b>, es posible agregar la forma para factuar el pedido.
            </p>
            <p>
                Los pedidos que ya han sido pagados, recibirán su factura inmediatamente.<br />
                <b>Los pedidos que no se hayan pagado en este momento</b> tales como OXXO, 7Eleven, SPEI, etc. recibirán la factura
                recibirán una confirmación mencionando que recibirán la factura cuando se confirme el pago.
            </p>
            <ImageFooted explanation={`La imagen superior muestra la forma de facturación en el "Thank you" page después de la compra.`}>
                <IMG_Shopify file={'onCheckout'} />
            </ImageFooted>
            <h3>
                Pasos para agregar la forma de facturación en "Thank You"
            </h3>
            <IMG_Shopify file={'checkoutSettingsIcon'} />
            <p>
                <b>La sección de facturación después de la compra se configura en el bloque de "Checkout" en los Settings principales de Shopify.</b><br />
                Sigue los pasos para activar el formato de facturación en la sección de "Thank You" después de la compra.
            </p>

            <Tabulator>
                <TabEntry label="Paso 1" sublabel="Ir a Configuración">
                    <ImageFooted
                        explanation={`1. Acceder a Configuración (Settings) desde tu Admin de Shopify, que se encuentra en la parte inferior izquierda.\nEn la vista de Configuración, ir al bloque que "Checkout" y en ella dar click en Customize.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onCheckoutSettings'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 2" sublabel="Acceder a Thank You">
                    <ImageFooted
                        explanation={`2. Al entrar a la sección de "Customize" del Checkout, seleccionamos la sección de "Thank You" en la parte superior y en el menú izquierdo dar click al primer ícono de "Sections" para ver las secciones disponibles a editar.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onCheckoutThankYou'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 3" sublabel="Agregar FiscalPOP">
                    <ImageFooted
                        explanation={`3. Al dar click en el ícono de "Sections", verás las secciónes de "Thank you".\nLos links azules de "Add app Block" te permiten agregar la app de FiscalPOP en alguna de las secciónes, recomendamos en la sección de "Order details" como en la imagen superior.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onThankYouAddBlock'} />
                    </ImageFooted>
                </TabEntry>
                <TabEntry label="Paso 4" sublabel="Guardar cambios">
                    <ImageFooted
                        explanation={`4. Una vez agregada la app, daremos click en "Save" en la parte superior izquierda para guardar los cambios realizados.\nUna vez aplicados los cambios, la forma de facturación estará disponible.`}
                        ignoreWidthAdjust={true}
                    >
                        <IMG_Shopify file={'onThankYouSave'} />
                    </ImageFooted>
                </TabEntry>
            </Tabulator>
            <p>
                Si necesitas orientación en configurarla, escríbenos a <a href="mailto:soporte@fiscalpop.com">soporte@fiscalpop.com</a>
            </p>
            <SectionNavigate previous={`/ecommerce/shopify/agregar-pagina-facturacion`} next={`/ecommerce/shopify/facturacion-en-order-status`} />
        </div>
    </Layout>
)

export default ShopifyFacturacionCheckout;